import IVersion from '../IVersion';

// The average hourly earnings (KTA, €/h) a new position starts with; the user can change it
export const DEFAULT_AVERAGE_HOURLY_EARNINGS = '25';

const getDefaultVersion = (): IVersion => ({
  averageHourlyEarnings: DEFAULT_AVERAGE_HOURLY_EARNINGS,
  id: 0,
  installerCount: '1',
  installations: [],
  offerText: '',
  isPrimary: true,
  name: '',
  showInOfferPdf: true,
  subproducts: [],
  calculationReviews: [],
  // The summary rows of subcontracting and own production start as the installation contract
  subcontractingAverageHourlyEarnings: DEFAULT_AVERAGE_HOURLY_EARNINGS,
  subcontractingInstallerCount: '1',
  ownProductionAverageHourlyEarnings: DEFAULT_AVERAGE_HOURLY_EARNINGS,
  ownProductionInstallerCount: '1',
});

export default getDefaultVersion;
